import React, { createContext, useContext, useState } from 'react';

const LanguageContext = createContext();

export const translations = {
  en: {
    topMessage: "You are not alone. There is hope. We are here for you.",
    navWhatWeAre: "What are we?",
    navWhatWeDo: "What do we do?",
    navMyExperience: "My Experience",
    heroBadge: "SELF-HELP GROUP",
    heroTyping1: "Feeling an existential void",
    heroTyping2: "Feeling alone even when accompanied",
    heroTyping3: "Abandoning your projects due to lack of motivation",
    heroTyping4: "The anguish of your physical appearance",
    heroHighlight: "has an answer.",
    heroSubtitle: "You don't have to face anxiety, depression, or frustration alone. We are an anonymous group dedicated to helping you find inner peace.",
    heroWhatsapp: "Contact us on WhatsApp",
    heroEmail: "Send Email",
    heroStat1Label: "Groups in Illinois and Mississippi",
    heroStat2Label: "Years of age",
    heroStat3Label: "Always available",
    infoSectionBadge: "We can help you",
    infoSectionTitle: "Do you identify with any of these symptoms?",
    card1Title: "Alcoholism and drug addiction",
    card1P1: "Have you left any responsibility or project to drink, use drugs, or prioritize an emotional relationship?",
    card1P2: "Have you drunk or used drugs to the point of losing memory, making a fool of yourself, or having violent outbursts?",
    card1P3: "Has your economy been affected by the way you drink or use drugs?",
    card2Title: "Neurosis",
    card2P1: "Do you frequently think that life is unfair or that people want to harm you or don't love you enough?",
    card2P2: "Do you feel or do people around you perceive you as irritable, moody, or constantly angry?",
    card2P3: "Do you feel alone even in moments when you are accompanied?",
    card3Title: "Depression and Anxiety",
    card3P1: "Do you live in states of emotional emptiness where you feel that life has no meaning?",
    card3P2: "Have you tried to take your own life or thought about doing so?",
    card3P3: "Have you abandoned plans or projects and cannot resume them due to your emotional state?",
    card4Title: "Eating disorders",
    card4P1: "Has the anguish of your physical appearance led you to stop eating for several hours, or vomit what you eat?",
    card4P2: "When you eat, do you eat excessively and feel guilty about it?",
    card4P3: "Do you feel fear before eating to the point of excessively measuring what you eat?",
    card5Title: "Codependency",
    card5P1: "Do you tend to do things to please and get approval or acceptance from other people (your parents, partner, friends, etc.)?",
    card5P2: "In your search for this approval or acceptance from others, do you give up what you long for or want?",
    mapTitle: "FIND YOUR NEAREST GROUP",
    mapSubtitle: "Fuego de Vida Directory",
    queSomosTitle: "One day at a time",
    queSomosText: "We are an anonymous non-profit self-help group dedicated to working and understanding various symptoms and discomforts of emotional illness, such as neurosis, depression, anxiety, codependency, eating disorders, alcoholism, drug addiction, etc.",
    queSomosAgeTitle: "FOR PEOPLE BETWEEN 13 AND 70 YEARS OLD",
    queSomosAgeText: "No matter your social class, ethnicity, belief, religion, or political party.",
    learnMore: "Learn more",
    queHacemosLabel: "WHAT DO WE DO?",
    nuevaVisionTitle: "A new vision",
    nuevaVisionText: "Our method is based on reviewing specific areas of our personality in order to find solutions to our current problems, finding their origin in our past, having as a result of this experience a better understanding of our past, a better understanding of our present, and a different stance to face the future.",
    porQueTitle: "Why do we do it?",
    porQueText: "We realized that giving ourselves to other human beings without expecting anything in return helped us recover and stay sober one day at a time.",
    knowMore: "Know more",
    expStep1Title: "IDENTIFY YOUR NEAREST GROUP",
    expStep1Text: "There are more than 7 groups in Illinois and Mississippi, identify the one closest to your home.",
    expStep2Title: "ATTEND YOUR PREPARATION MEETINGS",
    expStep2Text: "These are meetings that will help you prepare to live your experience.",
    expStep3Title: "LIVE YOUR EXPERIENCE",
    expStep3Text: "Here you will make a moral inventory of yourself, you will be able to identify the origin of your problems.",
    expHeader: "MY EXPERIENCE",
    expMoment: "It's your moment.",
    expDescription: "We create an experiential, intensely reflective experience. We generate a favorable climate for deep introspection about our past and present in order to find answers to our current problems.",
    expStart: "Start",
    footerTitle: "There will always be someone to listen to you. You are no longer alone.",
    footerWhatsapp: "Whatsapp",
    footerWhatsappText: "Send us a Whatsapp",
    footerEmail: "Email",
    footerEmailText: "We will respond as quickly as we can",
    footerCopyright: "Copyright © 2023 Fuego de Vida Anonymous Self-Help Groups",
    emailAddress: "help@fuegodevidausa.org",
    // Que no somos section (Bubbles)
    queNoSomosTitle: "WHAT ARE WE NOT?",
    queNoSomosSubtitle: "We are not professionals, but we know what we do",
    queNoSomosText: "We are not AA, the issues we address are not solely focused on alcohol or drug consumption, nor are we a religion, our members are free to profess any belief or creed and even not to do so. We are not a cult, if you come to any Fuego de Vida group, you will be welcome, and you will be completely free to choose whether or not to be part of our community. We are not professionals and we do not pretend to be, our work is not experimental, Fuego de Vida has more than 19 years in which we have managed to positively influence the lives of thousands of people.",
    bubble1Text: "More than 15,000 lives changed",
    bubble2Text: "More than 7 groups in Illinois and Mississippi",
    bubble3Text: "More than 19 years of operation",
  },
  es: {
    topMessage: "No estás solo. Hay esperanza. Estamos aquí para ti.",
    navWhatWeAre: "¿Qué somos?",
    navWhatWeDo: "¿Qué hacemos?",
    navMyExperience: "Mi Experiencia",
    heroBadge: "GRUPO DE AUTOAYUDA",
    heroTyping1: "El sentir vacío existencial",
    heroTyping2: "Sentirse solo aún estando acompañado",
    heroTyping3: "Abandonar tus proyectos por falta de motivación",
    heroTyping4: "La angustia de tu apariencia física",
    heroHighlight: "tiene una respuesta.",
    heroSubtitle: "No tienes que enfrentar la ansiedad, depresión o frustración solo. Somos un grupo anónimo dedicado a ayudarte a encontrar paz interior.",
    heroWhatsapp: "Contáctanos por WhatsApp",
    heroEmail: "Enviar Email",
    heroStat1Label: "Grupos en Illinois y Mississippi",
    heroStat2Label: "Años de edad",
    heroStat3Label: "Siempre disponibles",
    infoSectionBadge: "Podemos ayudarte",
    infoSectionTitle: "¿Te identificas con alguno de estos síntomas?",
    card1Title: "Alcoholismo y drogadicción",
    card1P1: "¿Has dejado alguna responsabilidad o proyecto por beber, drogarte o priorizar una relación afectiva?",
    card1P2: "¿Has bebido o te has drogado al grado de perder la memoria, hacer el ridículo, o tener arranques de violencia?",
    card1P3: "¿Tu economía se ha visto afectada por tu manera de beber o drogarte?",
    card2Title: "Neurosis",
    card2P1: "¿Frecuentemente piensas que la vida es injusta o que las personas te quieren dañar o que no te aman lo suficiente?",
    card2P2: "¿Te sientes o las personas a tu alrededor te perciben irritable, de mal humor o enojado constantemente?",
    card2P3: "¿Te sientes solo aún en momentos en los que estás acompañado?",
    card3Title: "Depresión y Ansiedad",
    card3P1: "¿Vives en estados de vacío emocional en los que sientes que la vida no tiene sentido?",
    card3P2: "¿Has intentado quitarte la vida o has pensado en hacerlo?",
    card3P3: "¿Has abandonado planes o proyectos y no logras retomarlos debido a tu estado emocional?",
    card4Title: "Trastornos alimenticios",
    card4P1: "¿La angustia de tu apariencia física te ha llevado a dejar de comer por varias horas, o vomitar lo que comes?",
    card4P2: "¿Cuándo comes, lo haces en exceso y sientes culpa al respecto?",
    card4P3: "¿Sientes miedo antes de comer que puedes llegar al grado de medir exageradamente lo que comes?",
    card5Title: "Codependencia",
    card5P1: "Tiendes a hacer cosas con el fin de complacer y obtener aprobación o aceptación de otras personas (tus padres, pareja, amigos, etc).",
    card5P2: "En tu búsqueda de esta aprobación o aceptación de otros, ¿renuncias a lo que tu anhelas o deseas?",
    mapTitle: "ENCUENTRA TU GRUPO MÁS CERCANO",
    mapSubtitle: "Directorio Fuego de Vida",
    queSomosTitle: "Un día a la vez",
    queSomosText: "Somos un grupo anónimo de autoayuda sin fines de lucro dedicado a trabajar y entender diversos síntomas y malestares de la enfermedad emocional, tales como neurosis, depresión, ansiedad, codependencia, desórdenes alimenticios, alcoholismo, drogadicción, etc.",
    queSomosAgeTitle: "PARA PERSONAS ENTRE 13 Y 70 AÑOS",
    queSomosAgeText: "No importa tu clase social, etnia, creencia, religión o partido político.",
    learnMore: "Conocer más",
    queHacemosLabel: "¿QUÉ HACEMOS?",
    nuevaVisionTitle: "Una nueva visión",
    nuevaVisionText: "Nuestro método está basado en revisar áreas específicas de nuestra personalidad con la finalidad de encontrar solución a nuestros problemas actuales, encontrando su origen en nuestro pasado, teniendo como resultado de esta experiencia una mejor comprensión de nuestro pasado, un mejor entendimiento de nuestro presente y una postura distinta para afrontar el futuro.",
    porQueTitle: "¿Por qué lo hacemos?",
    porQueText: "Nos dimos cuenta de que entregarnos a otros seres humanos sin esperar nada a cambio, nos ayudaba a recuperarnos y mantenernos sobrios un día a la vez.",
    knowMore: "Saber más",
    expStep1Title: "IDENTIFICA TU GRUPO MÁS CERCANO",
    expStep1Text: "Hay más de 7 grupos en Illinois y Mississippi, identifica el más cerca a tu casa.",
    expStep2Title: "ASISTE A TUS JUNTAS DE PREPARACIÓN",
    expStep2Text: "Estas son juntas que te van a ayudar a prepararte para vivir tu experiencia.",
    expStep3Title: "VIVE TU EXPERIENCIA",
    expStep3Text: "Aquí irás a hacer un inventario moral de ti mismo, podrás identificar el origen de tus problemas.",
    expHeader: "MI EXPERIENCIA",
    expMoment: "Es tu momento.",
    expDescription: "Creamos una experiencia vivencial, de intensa reflexión. Generamos un clima propicio para la introspección profunda sobre nuestro pasado y presente con el fin de encontrar respuestas a nuestros problemas actuales.",
    expStart: "Comenzar",
    footerTitle: "Siempre habrá alguien para escucharte. Ya no estás solo.",
    footerWhatsapp: "Whatsapp",
    footerWhatsappText: "Envíanos un Whatsapp",
    footerEmail: "Email",
    footerEmailText: "Te contestaremos tan rápido como podamos",
    footerCopyright: "Copyright © 2023 Fuego de Vida Grupos Anónimos de Autoayuda",
    // Que no somos section (Bubbles)
    queNoSomosTitle: "¿QUÉ NO SOMOS?",
    queNoSomosSubtitle: "No somos profesionales, pero sabemos lo que hacemos",
    queNoSomosText: "No somos AA, las problemáticas a las que atendemos no se centran únicamente en el consumo de alcohol o drogas, tampoco somos una religión, nuestros miembros son libres de profesar cualquier creencia o credo e incluso de no hacerlo. No somos una secta, si tu llegas a cualquier grupo de Fuego de Vida, serás bienvenido, y estarás en toda la libertad de elegir ser o no parte de nuestra comunidad. No somos profesionales y no pretendemos serlo, nuestro trabajo no es experimental, Fuego de Vida tiene más de 19 años en los cuales hemos logrado influir positivamente en la vida de miles de personas.",
    bubble1Text: "Más de 15,000 vidas cambiadas",
    bubble2Text: "Más de 7 grupos en Illinois y Mississippi",
    bubble3Text: "Más de 19 años de funcionamiento",
  }
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(null);

  const t = (key) => {
    if (!language) return translations.es[key] || key;
    return translations[language][key] || key;
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};